import LanguageIcon from "@material-ui/icons/Language";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIcon from "@material-ui/icons/Phone";
import RoomIcon from "@material-ui/icons/Room";
import ShareIcon from "@material-ui/icons/Share";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import YouTubeIcon from "@material-ui/icons/YouTube";
import styled from "styled-components";

interface PropsIcon {
  visible: boolean;
}

interface PropsLik {
  href: string;
}

interface PropsLike {
  curti: boolean;
}

export const Contanier = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  /* background-color: red; */
  margin: 0 5%;
`;

export const ContainerIcon = styled.div`
  display: ${(props: PropsIcon) => (props.visible ? "flex" : "none")};
`;

export const IconSite = styled(LanguageIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;
export const IconVideo = styled(YouTubeIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;
export const IconPhone = styled(PhoneIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;
export const IconMap = styled(RoomIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;
export const IconEmail = styled(MailOutlineIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;
export const IconZap = styled(WhatsAppIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;
export const IconShare = styled(ShareIcon)`
  &:hover {
    color: #0001;
    zoom: 1;
    cursor: pointer;
  }
`;

export const ContainerIconLike = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const IconLike = styled(ThumbUpAltIcon)`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  color: ${(props: PropsLike) => (props.curti === true ? "green" : "#000")};
  &:hover {
    color: "#0001";
    zoom: 1;
    cursor: pointer;
  }
`;

export const LabelLike = styled.p`
  display: flex;
  font-size: calc(12px+1vw);
  align-items: flex-end;
  justify-content: flex-end;
  color: green;
  margin-left: 2px;
`;

export const Action = styled.a`
  :link {
    color: #000;
  }
  :visited {
    color: #000;
  }
  :hover {
    color: #0001;
  }
  :active {
    color: #000;
  }
`;
